import "./App.css";
import SideBar from "./Components/Sidebar/SideBar.jsx";
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "./Components/hrNavbar.js";
import OverTimeReport from "./Pages/OverTime/my-overtime-report.js";
import Settings from "./Pages/AccountSetting/account-settings.js";
import ResetPassword from "./Pages/AccountSetting/reset-password.js";
import EmpPayroll from "./Pages/Payroll/PayrollInfo/emp-payroll.js";
import PayrollInfo from "./Pages/Payroll/PayrollInfo/payroll.js";
import ProcessPayroll from "./Pages/Payroll/process-payroll.js";
import PayrollReports from "./Pages/Payroll/payroll-report.js";
import PasswordReset from "./Pages/PasswordReset.js";
import ForgotPassword from "./Pages/ForgotPassword.js";
import Salary from "./Pages/MySalary/my-salary.js";
import AccSignin from "./Common/Signin.jsx";
import Profile from "./Pages/Profile/my-profile.js";
import Announcement from "./Pages/MyAnnouncement/Annoncement.jsx";
import DeptAnnouncement from "./Pages/MyAnnouncement/my-dept-announcement.jsx";
import MySchedule from "./Pages/Schedule/my-schedule.js";
import ApprovedLeave from "./Pages/MyLeave/my-approved-leave.js";
import RejectedLeave from "./Pages/MyLeave/my-rejected-leave.js";
import MyPayroll from "./Pages/My-Payroll/payroll-report.js";
import PayinVoice from "./Pages/My-Payroll/pay-invoice.js";
import ProvidentFund from "./Pages/PFund/provident-fund.js";
import AddReport from "./Pages/MyWorkReport/add-report.js";
import WorkReports from "./Pages/MyWorkReport/my-work-reports.js";
import MyEditWorkReport from "./Pages/MyWorkReport/my-edit-report.js";
import TimeHistory from "./Pages/TimingHistory/time-history.js";
import TimingsHistory from "./Pages/TimingHistory/timings-history.js";
import CurrentAtd from "./Pages/EmpAtd/current-atd.js";
import YesterdayAttendance from "./Pages/EmpAtd/yesterday-atd.js";
import ViewAtd from "./Pages/EmpAtd/view-atd.js";
import AllEmps from "./Pages/EmpAtd/all-emps.js";
import MonthlyAtd from "./Pages/EmpAtd/current-month-atd.js";
import { ViewAtdDay } from "./Pages/EmpAtd/view-atd-day.js";
import AddAtd from "./Pages/EmpAtd/add-atd.js";
import EditAtd from "./Pages/EmpAtd/edit-atd.js";
import Dashboard from "./Pages/Dashboard/Dashboard.js";
import Handbook from "./Pages/Handbook/handbook.js";
import Rules from "./Pages/Rules/rules.js";
import EditPayroll from "./Pages/Payroll/PayrollInfo/edit-payroll.js";
import AddAnnouncements from "./Pages/Announcments/Add-Announcements.jsx";
import EditAnnouncements from "./Pages/Announcments/Edit-Announcements.jsx";
import EmpAnnouncements from "./Pages/Announcments/Emp-Announcments.jsx";
import DeptAnnouncements from "./Pages/DeptAnnouncements/DeptAnnouncements.jsx";
import AddDeptAnnouncements from "./Pages/DeptAnnouncements/Add-DeptAnnouncements.jsx";
import AddUserAnnouncements from "./Pages/Announcments/Add-userAnnouncements.jsx";
import EditUserAnnouncements from "./Pages/Announcments/Edit-UserAnnouncements.jsx";
import UserAnnouncements from "./Pages/Announcments/Emp-UserAnnouncments.jsx";
import EditDeptAnnouncements from "./Pages/Announcments/Edit-DeptAnnouncement.js";
import axios from 'axios';
import { useState } from "react";
import { useEffect } from "react";
import NotAssigned from "./Components/NotAssigned.jsx";
import TeamChart from "./Pages/TeamChart.js"
import PendingLeave from "./Pages/LeaveNew/pending-Leave";
import LeaveLayout from "./Components/LeaveLayout.jsx";
import AddLeave from "./Pages/LeaveNew/addleave";
import LeaveBalance from "./Pages/LeaveNew/LeaveBalance";
import LeaveManagement from './Pages/ManagerLeaveSystem/LeaveManagement.js'; 
import PFManagement from './Pages/EmpBenefit/pfManagement.js';
import PfPastYears from './Pages/EmpBenefit/PFPastYear.js';
import EmployeeInformation from "./Pages/AddEmp/emp-info.js";
import AddEmp from "./Pages/AddEmp/add-emp.js";
import EditEmployee from "./Pages/AddEmp/edit-emp.js";
import ExEmployeeInformation from './Pages/AddEmp/ex-emp-info.js';
import EmpsSchedule from "./Pages/EmpSchedule/emps-schedule.js";
import EditTiming from './Pages/EmpSchedule/edit-timing.js';
import EmpTiming from "./Pages/EmpSchedule/emps-timing.js";
import HrSchedule from "./Pages/HrSchedule/hr-schedule.js";
import EditHrTiming from './Pages/HrSchedule/edit-hr-timing.js';
import UnseenAnnouncementsDialog from "./Components/UnseenAnnouncementsDialog";

// Protected Route Component
const ProtectedRoute = ({ element, allowedPaths, isLoading }) => {
  const isAuthenticated = localStorage.getItem('accessToken') && localStorage.getItem('refreshToken');
  const location = useLocation();
  const currentPath = location.pathname.replace(/^\/+/, '');

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to AccessDenied');
    return <NotAssigned />;
  }

  if (isLoading) {
    console.log('Loading allowed paths...');
    return <div>Loading...</div>;
  }

  const normalizedAllowedPaths = allowedPaths.map(path => path.replace(/^\/+/, ''));
  
  // Check if current path is allowed (including wildcard matching)
  const isAllowed = normalizedAllowedPaths.some(path => {
    if (currentPath === path) return true;
    // Check if path matches with parameters (e.g., /edit-emp/:userId)
    if (path.includes(':')) {
      const pathSegments = path.split('/');
      const currentSegments = currentPath.split('/');
      if (pathSegments.length !== currentSegments.length) return false;
      return pathSegments.every((segment, index) => {
        if (segment.startsWith(':')) return true;
        return segment === currentSegments[index];
      });
    }
    return false;
  });

  console.log('Current path:', currentPath, 'Normalized allowed paths:', normalizedAllowedPaths, 'Is allowed:', isAllowed);

  return isAllowed ? element : <NotAssigned />;
};

const MainLayout = () => {
  const [showUnseenDialog, setShowUnseenDialog] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const shouldShow = localStorage.getItem('shouldShowUnseenDialog');
    const lastLoginTime = localStorage.getItem('lastLoginTime');
    const lastDialogShown = localStorage.getItem('lastDialogShownTime');
    
    if (shouldShow === 'true') {
      if (!lastDialogShown || (lastLoginTime && parseInt(lastLoginTime) > parseInt(lastDialogShown))) {
        setShowUnseenDialog(true);
        localStorage.setItem('lastDialogShownTime', Date.now().toString());
        localStorage.removeItem('shouldShowUnseenDialog');
      }
    }
  }, []);

  const handleNavigateToAnnouncements = (announcement = null) => {
    setShowUnseenDialog(false);
    
    setTimeout(() => {
      if (announcement) {
        navigate('/announcements', { 
          state: { 
            selectedAnnouncement: announcement,
            fromNotification: true 
          } 
        });
      } else {
        navigate('/announcements', { 
          state: { fromNotification: true } 
        });
      }
    }, 100);
  };

  return (
    <>
      <SideBar>
        <div className="content-container">
          <Navbar />
          <Routes>
            <Route path="edit-hr-timing/:userId" element={<EditHrTiming />} />
            <Route path="hr-schedule" element={<HrSchedule />} />
            <Route path="emps-timing/:userId" element={<EmpTiming />} />
            <Route path="edit-timing/:userId" element={<EditTiming />} />
            <Route path="emps-schedule" element={<EmpsSchedule />} />
            <Route path="ex-emp-info" element={<ExEmployeeInformation />} />
            <Route path="edit-emp/:userId" element={<EditEmployee />} />
            <Route path="emp-info" element={<EmployeeInformation />} />
            <Route path="add-emp" element={<AddEmp />} />
            <Route path="emp-payroll" element={<EmpPayroll />} />
            <Route path="payroll" element={<PayrollInfo />} />
            <Route path="process-payroll" element={<ProcessPayroll />} />
            <Route path="payroll-report" element={<PayrollReports />} />
            <Route path="my-salary" element={<Salary />} />
            <Route path="my-overtime-report" element={<OverTimeReport />} />
            <Route path="account-settings" element={<Settings />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="profile" element={<Profile />} />
            <Route path="announcements" element={<Announcement />} />
            <Route path="dept-announcement" element={<DeptAnnouncement />} />
            <Route path="my-schedule" element={<MySchedule />} />
            <Route path="leave-management" element={<LeaveManagement />} />
            <Route path="my-payroll" element={<MyPayroll />} />
            <Route path="pay-invoice" element={<PayinVoice />} />
            <Route path="provident-fund" element={<ProvidentFund />} />
            <Route path="add-report" element={<AddReport />} />
            <Route path="my-work-reports" element={<WorkReports />} />
            <Route path="my-edit-report/:reportId" element={<MyEditWorkReport />} />
            <Route path="time-history" element={<TimeHistory />} />
            <Route path="timings-history" element={<TimingsHistory />} />
            <Route path="current-atd" element={<CurrentAtd />} />
            <Route path="yesterday-atd" element={<YesterdayAttendance />} />
            <Route path="view-atd" element={<ViewAtd />} />
            <Route path="all-emps" element={<AllEmps />} />
            <Route path="current-month-atd/:userId" element={<MonthlyAtd />} />
            <Route path="view-atd-day" element={<ViewAtdDay />} />
            <Route path="add-atd" element={<AddAtd />} />
            <Route path="edit-atd/:attendanceId" element={<EditAtd />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="handbook" element={<Handbook />} />
            <Route path="rules" element={<Rules />} />
            <Route path="edit-payroll/:id" element={<EditPayroll />} />
            <Route path="pay-invoice/:id" element={<PayinVoice />} />
            <Route path="add-announcements" element={<AddAnnouncements />} />
            <Route path="edit-announcement/:id" element={<EditAnnouncements />} />
            <Route path="emp-announcements" element={<EmpAnnouncements />} />
            <Route path="dept-announcements" element={<DeptAnnouncements />} />
            <Route path="add-dept-announcements" element={<AddDeptAnnouncements />} />
            <Route path="edit-dept-announcement/:id" element={<EditDeptAnnouncements />} />
            <Route path="add-user-announcements" element={<AddUserAnnouncements />} />
            <Route path="edit-user-announcements/:id" element={<EditUserAnnouncements />} />
            <Route path="user-announcements" element={<UserAnnouncements />} />
            <Route path="team-chart" element={<TeamChart />} />
            <Route path="provident-fund-management" element={<PFManagement />} />
            <Route path="pf-past-years" element={<PfPastYears />} />
            <Route path="my-leaves-status" element={<PendingLeave />} />
            <Route path="leavemanager" element={<LeaveManagement />} />
            <Route path="add-leave" element={<LeaveLayout />}>
              <Route index element={<AddLeave />} />
            </Route>
            <Route path="leave" element={<LeaveLayout />}>
              <Route index element={<AddLeave />} />
              <Route path="add-leave" element={<AddLeave />} />
              <Route path="pending" element={<PendingLeave />} />
              <Route path="approved" element={<ApprovedLeave />} />
              <Route path="rejected" element={<RejectedLeave />} />
              <Route path="leave-balance" element={<LeaveBalance />} />
            </Route>
          </Routes>
        </div>
      </SideBar>
      
      <UnseenAnnouncementsDialog
        show={showUnseenDialog}
        onClose={() => setShowUnseenDialog(false)}
        onNavigateToAnnouncements={handleNavigateToAnnouncements}
      />
    </>
  );
};

function App() {
  const [allowedPaths, setAllowedPaths] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAllowedPaths = async () => {
      try {
        // Get user's panel from localStorage
        const userPanel = localStorage.getItem('panel') || 'AccountsPanel';
        
        const response = await axios.get(`https://backend.ems.hiradentallab.com/api/panel-pages/panel/${userPanel}`, {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          },
        });
        const paths = response.data.flatMap(pp => [
          pp.page.path,
          ...(pp.page.subRoutes || []).map(subRoute => subRoute.path),
        ]);
        console.log('Fetched allowed paths for', userPanel, ':', paths);
        setAllowedPaths(paths);
      } catch (error) {
        console.error('Error fetching allowed paths:', error);
        // Fallback with common paths including announcements
        setAllowedPaths(['/dashboard', '/announcements', '/profile', '/my-salary']);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllowedPaths();
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<AccSignin />} />
        <Route path="password-reset" element={<PasswordReset />} />
        <Route path="forgotpassword/:userId/:token" element={<ForgotPassword />} />

        {/* Protected Routes */}
        <Route path="/*" element={
          <ProtectedRoute
            allowedPaths={allowedPaths}
            isLoading={isLoading}
            element={<MainLayout />}
          />
        } />
      </Routes>
    </Router>
  );
}

export default App;